__turbopack_context__.v({
  "pageRoot": "styles-module__MXUkXq__pageRoot",
});
